"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebViewTypeEnum = void 0;
/**
 * WebView 类型枚举。
 */
var WebViewTypeEnum;
(function (WebViewTypeEnum) {
    /**
     * WebKit Android
     */
    WebViewTypeEnum["WebView"] = "WebKit";
    /**
     * WKWebview iOS
     */
    WebViewTypeEnum["WKWebview"] = "WKWebview";
    /**
     * UIWebview iOS
     *
     * @deprecated 性能因素被抛弃
     */
    WebViewTypeEnum["UIWebview"] = "UIWebview";
    /**
     * Browser
     *
     * @description 浏览器
     *
     */
    WebViewTypeEnum["Browser"] = "Browser";
    /**
     * WeChatMPWebView
     */
    WebViewTypeEnum["WeChatMPWebView"] = "WeChatMPWebView";
})(WebViewTypeEnum = exports.WebViewTypeEnum || (exports.WebViewTypeEnum = {}));
//# sourceMappingURL=WebViewTypeEnum.js.map